<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import WorkOrderTableSummaryCell from "./_modules/work-order-table-summary-cell"
  import type { AssignWorkOrderDraft, WorkOrderAssignmentRow } from "../../contract"
  import { workOrderAssignmentSummaryDisplay } from "../../_shared/_logic/01-assign-work-order-presentation"

  let props: InboxWorkflowCellProps = $props()

  const row = $derived(props.row as unknown as WorkOrderAssignmentRow)
  const draft = $derived(props.draft as unknown as Partial<AssignWorkOrderDraft>)
  const display = $derived(workOrderAssignmentSummaryDisplay(row, draft))
</script>

<WorkOrderTableSummaryCell
  workOrder={display.workOrder}
  label={display.label}
  subLabel={display.subLabel}
  orderNumber={display.orderNumber}
  orderTypeLabel={display.orderTypeLabel}
  disabled={props.binding.disabled || row.disabled || !row.workOrderId || !row.scheduleEventId}
/>
